import * as yup from "yup";

/**
 * @description - Validation schema for intents form
 */
export default yup.object({
  name: yup.string().required(),
  type: yup.string().required(),
});
